/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
// import SecuredImage from 'modules/common/components/SecuredImage';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import * as action from '../action';
import * as c from '../constant';

function UpdateMarriageModal({
  profile,
  setFormData,
  formData,
  createUpperCaseInput,
  updateMarriageCertificate,
  syncToEs,
  getMarriageCertificateList,
  showMarriageCertificate,
  history,
  updating,
  syncing,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      registry_number: profile.attributes.registry_number || '',
      husband_first_name: profile.attributes.husband_first_name || '',
      husband_last_name: profile.attributes.husband_last_name || '',
      husband_middle_name: profile.attributes.husband_middle_name || '',
      wife_first_name: profile.attributes.wife_first_name || '',
      wife_last_name: profile.attributes.wife_last_name || '',
      middle_name: profile.attributes.middle_name || '',
      date_marriage: profile.attributes.date_marriage || '',
      wife_middle_name: profile.attributes.wife_middle_name || '',
      volume: profile.attributes.volume || '',
      // fatal: profile.attributes.fatal || '',
      // front_page: profile.attributes.front_page || '',
      // back_page: profile.attributes.back_page || '',
    });
  };

  // const onUpload = (side) => (e) => {
  //   e.preventDefault();

  //   const reader = new FileReader();
  //   const file = e.target.files[0];

  //   reader.onloadend = () => {
  //     setFormData({
  //       ...formData,
  //       [`${side}`]: reader.result,
  //       [`${side}_file`]: file,
  //     });
  //   };

  //   reader.readAsDataURL(file);
  // };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData
    }

    args.husband_first_name = args.husband_first_name.toUpperCase();
    args.husband_last_name = args.husband_last_name.toUpperCase();
    args.husband_middle_name = args.husband_middle_name.toUpperCase();

    args.wife_first_name = args.wife_first_name.toUpperCase();
    args.wife_last_name = args.wife_last_name.toUpperCase();
    args.wife_middle_name = args.wife_middle_name.toUpperCase();

    updateMarriageCertificate(profile.id, args, ({ data }) => {
      getMarriageCertificateList();
      setModal({ isOpen: false });
      showMarriageCertificate(profile.id);
      syncToEs({ id: profile.id });
      history.push(
        `/civil-registry/marriage-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
      // UpdateInfo();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="">Document&apos;s Owner Personal Information</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-12">Name of Man/Husband</div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'registry_number', label: 'Registry Number:' },
              { required: true, placeholder: 'registry_number' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_middle_name', label: 'Middle Name:' },
              { required: false, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_first_name', label: 'First Name' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-12">Name of Lady/Wife</div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_middle_name', label: 'Middle Name:' },
              { required: false, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_first_name', label: 'First Name' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'volume', label: 'Volume' },
              { required: true, placeholder: 'volume'}
            )}
          </div>
          {/* <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'fatal', label: 'Fatal' },
              { required: true, placeholder: 'fatal' }
            )}
          </div> */}
          <div className="col-3 form-group">
            <label className="form-control-plaintext form-label">
              Date of Marriage:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date_marriage')}
              value={_.get(formData, 'date_marriage') || ''}
              maxDate={new Date()}
            />
          </div>
        </div>
        {/* <div className="">Death Certificates</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-md-6">
            <label>Front</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="BC"
                src={_.get(formData, 'front_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('front_page')}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label>Back</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="BC"
                src={_.get(formData, 'back_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('back_page')}
              />
            </div>
          </div>
        </div> */}

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || syncing}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating || syncing ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            disabled={updating || syncing}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateMarriageModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  syncToEs: PropTypes.instanceOf(Function).isRequired,
  getMarriageCertificateList: PropTypes.instanceOf(Function).isRequired,
  showMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createUpperCaseInput: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_MARRIAGE_CERTIFICATE}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_MARRIAGE_CERTIFICATE) > -1,
  syncing: api.loading.indexOf(c.SYNC_TO_ES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateMarriageModal);
